import { apiClient } from './api'

export interface StatusReport {
  project_id: number
  project_name: string
  period_start: string
  period_end: string
  period_days: number
  generated_by: 'ai' | 'rules'
  health: 'on_track' | 'watch' | 'at_risk'
  progress_percent: number
  summary: string
  highlights: string[]
  watch_items: string[]
  completed_this_period: string[]
  overdue: Array<{ title: string; due: string }>
  due_next_period: Array<{ title: string; due: string }>
  upcoming_milestones: Array<{ name: string; due: string }>
  open_risks: number
  open_issues: number
  forecast_finish: string | null
  budget_spent_percent?: number | null
  /** Week-over-week movement since the last report that was sent; null on the first one. */
  changes?: StatusReportChanges | null
}

export interface StatusReportChanges {
  since: string
  health_before: StatusReport['health'] | null
  progress_delta: number | null
  forecast_slip_days: number | null
  budget_spent_delta: number | null
  newly_overdue: string[]
  no_longer_overdue: string[]
  open_risks_delta: number | null
  open_issues_delta: number | null
  lines: string[]
}

export interface ReportSubscribers {
  subscribers: Array<{ user_id: number; name: string; email: string; is_project_manager: boolean }>
  me_subscribed: boolean
}

export const statusReportService = {
  async preview(projectId: number, days = 7): Promise<StatusReport> {
    const { data } = await apiClient.get<StatusReport>(`/api/v1/projects/${projectId}/status-report`, { params: { days } })
    return data
  },
  async send(projectId: number, userIds: number[], days = 7): Promise<{ sent_to: number[]; failed: number[] }> {
    const { data } = await apiClient.post(`/api/v1/projects/${projectId}/status-report/send`, { user_ids: userIds, days })
    return data
  },
  async subscribers(projectId: number): Promise<ReportSubscribers> {
    const { data } = await apiClient.get<ReportSubscribers>(`/api/v1/projects/${projectId}/status-report/subscribers`)
    return data
  },
  async setSubscribed(projectId: number, subscribed: boolean): Promise<ReportSubscribers> {
    const url = `/api/v1/projects/${projectId}/status-report/subscribe`
    const { data } = subscribed ? await apiClient.post<ReportSubscribers>(url) : await apiClient.delete<ReportSubscribers>(url)
    return data
  },
}
